import { type EditorFrontType } from '@/src/Types/Blocks/Editor';
import { type HeadingType } from '@/src/Types/Shared/Heading';
import Heading from '@/src/Views/Shared/Heading/Heading';
import Html from '@Views/Shared/Html';

export default function EditorClassic(props: EditorFrontType) {
	const {
		id,
		title,
		titleFormat,
		description,
		content,
		containerType,
		wrapperType,
		headingAlign,
		headingFontClassName,
		contentFontClass,
		context,
		quoteStyle,
		tableStyle,
		sectionDecoration,
	} = props;

	const headingProps: HeadingType = {
		title: title,
		description: description,
		titleFormat: titleFormat,
		headingAlign: headingAlign,
		headingFontClassName: headingFontClassName,
		context: context,
	};

	let padding = '';
	if (sectionDecoration?.isSectionDecorated && sectionDecoration.type === 'wave') {
		padding = 'pt-8 pb-16 tablet:pt-12 tablet:pb-24 desktop:pb-32';
	} else {
		padding = 'py-3.5 tablet:py-6 desktop:py-12';
	}

	return (
		<div id={id} className={`minos-grid relative bg-minos-editor-bg-color ${padding}`}>
			<div
				data-aos='fade-up'
				className={`relative z-[11] col-start-2 col-end-14 ${
					containerType === 'block' &&
					'rounded-minos-editor-container border-minos-editor-container-border-width border-minos-editor-container-border-color bg-minos-editor-bg-container-color p-4 tablet:p-5 desktop:p-12'
				}`}
			>
				{/* mobile breakpoints handle in component */}
				<Heading {...headingProps} />
				{content ? (
					<div
						data-content='minos-content'
						className={`minos-editor-content-p col-start-2 col-end-14 max-w-3xl tablet:col-span-8 tablet:col-start-4 desktop:col-span-6 desktop:col-start-5 ${
							wrapperType === 'block' && 'm-auto'
						}`}
					>
						<Html
							context={context}
							html={content}
							tableStyle={tableStyle}
							quoteStyle={quoteStyle}
							className={contentFontClass?.text}
						/>
					</div>
				) : (
					''
				)}
			</div>
		</div>
	);
}
